import {
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import { VenueSurchargesForm, VenueSurchargesTable } from './components';

export const VenueSurcharges: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();
  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanEditVenueSurcharges = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-surcharges">
        <TouringCardHeader>
          <TouringCardTitle>{t('VENUE_SURCHARGES.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenueSurcharges && (
              <EditActionIcon onClick={openModal} />
            )}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <VenueSurchargesTable
            venueSurcharges={overviewVersion.venueSurcharges}
          />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_SURCHARGES.EDIT_MODAL_TITLE')}
      >
        <VenueSurchargesForm
          venueId={id}
          overviewVersion={version}
          venueSurcharges={overviewVersion.venueSurcharges}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
